import styles from "./styles/PosShoppingCart.module.css";
import InputText from "../../../components/ui/input_text/InputText";
import InputList from "../../../components/ui/input_list/InputList";
import InputDate from "../../../components/ui/input_date/InputDate";
import InputTextArea from "../../../components/ui/input_text_area/InputTextArea";
import { t } from "i18next";

const PosCardForm = ({
    handleChange, // {Function} - Function to handle input changes
    formInput, // {Object} - The current form input values
    hoverFlag, // {Boolean} - Indicates if the hover flag is active
    cardTypes, // {Array} - The array of available card types (Arrray of Strings)
}) => {
    return (
        <div className={`${styles.payment_input_container}  v-flex-container `}>
            <div className={`${styles.double_container} flex-container`}>
                <div
                    className={`${styles.payment_input_container} ${styles.double} `}
                >
                    <InputText
                        label={`${t("authorization code")}*`}
                        inputId={"authorizationCode"}
                        inputValue={formInput?.authorizationCode}
                        handleChangeFunction={handleChange}
                        required={hoverFlag && !formInput?.authorizationCode}
                        placeholder={`${t("required")}!`}
                        textAlign={"left"}
                        type={"text"}
                        fullWidth={true}
                    />
                </div>
                <div
                    className={`${styles.payment_input_container} ${styles.double}`}
                >
                    <InputDate
                        label={`${t("expiry date")}*`}
                        inputId={"expiryDate"}
                        inputValue={formInput?.expiryDate}
                        handleChangeFunction={handleChange}
                        required={hoverFlag && !formInput?.expiryDate}
                        fullWidth={true}
                        fromToday={true}
                    />
                </div>
            </div>
            <div className={`${styles.double_container} flex-container`}>
                <div
                    className={`${styles.payment_input_container} ${styles.double}`}
                >
                    <InputText
                        label={`${t("last 4 digits")}*`}
                        inputId={"last4Digits"}
                        inputValue={formInput?.last4Digits}
                        handleChangeFunction={handleChange}
                        required={
                            hoverFlag && formInput?.last4Digits?.length !== 4
                        }
                        placeholder={`${t("required")}!`}
                        letterSpacing={".5rem"}
                        textAlign={"center"}
                        maxLength={4}
                        type={"text"}
                        fullWidth={true}
                    />
                </div>
                <div
                    className={`${styles.payment_input_container} ${styles.double}`}
                >
                    <InputList
                        values={cardTypes}
                        label={t("card type")}
                        inputId={"cardType"}
                        inputValue={formInput?.cardType}
                        handleChangeFunction={handleChange}
                        required={hoverFlag && !formInput?.cardType}
                        placeholder={`${t("required")}!`}
                        textAlign={"left"}
                        type={"text"}
                        fullWidth={true}
                    />
                </div>
            </div>
            <div
                className={`${styles.payment_input_container} ${styles.payment_comment} flex-container`}
            >
                <InputTextArea
                    label={"comments"}
                    inputId={"comment"}
                    inputValue={formInput?.comment}
                    handleChangeFunction={handleChange}
                    textAlign={"left"}
                    type={"text"}
                    fullWidth={true}
                />
            </div>
        </div>
    );
};

export default PosCardForm;
